export default __webpack_public_path__ + "static/media/Scope-2.d70ed00f.png";